import * as React from 'react';
import styled from 'styled-components';

import { colorsV2 } from '../../colors-v2';
import { ProgressBar } from '../ProgressBar';

const Container = styled.div`
  cursor: pointer;
`;

interface AudioPlayerItemTimelineProps {
  currentTimeInSeconds?: number;
  durationInSeconds?: number;
  onSeek?: (seconds: number) => void;
  canSeek?: boolean;
}

export const AudioPlayerItemTimeline = (props: AudioPlayerItemTimelineProps) => {
  const { currentTimeInSeconds, durationInSeconds, onSeek, canSeek = false } = props;
  const ref = React.useRef(null);

  return (
    <Container
      ref={ref}
      className="audio-player-item-timeline"
      onClick={(e) => {
        if (canSeek) {
          const seeker = ref.current.getBoundingClientRect();
          const calculatedPercentage = 100 * (e.clientX - seeker.x) / seeker.width;
          onSeek?.((calculatedPercentage * durationInSeconds) / 100);
        }
      }}
    >
      <ProgressBar
        barColor={colorsV2.black10}
        progressColor={colorsV2.primary100}
        height={6}
        borderRadius={4}
        percentage={100 * currentTimeInSeconds / durationInSeconds}
      />
    </Container>
  );
};
